import { IAddServiceNumber } from '@/actions/reservenumber/models/types';
import axios from '@/helpers/axios';
import { inventoryApi } from '@/helpers/apis';

export const getReserveNumbers = (brn, reservedBy) => {
  const url = inventoryApi.GET_RESERVE_SERVICE_NOS_BRN_RESBY;
  const payload = { brn: brn, reservedBy: reservedBy };
  return axios.post(url, payload);
};
export const getNewLineReservedNumbers = (payload) => {
  const url = inventoryApi.GET_RESERVE_SERVICE_NOS_BRN_RESBY;
  return axios.post(url, payload);
};
export const addReserveNumbers = (payload: IAddServiceNumber) => {
  const url = inventoryApi.PUT_RESERVE_SERVICE_NOS;
  return axios.put(url, payload);
};
export const removeReserveNumbers = (payload: IAddServiceNumber) => {
  const url = inventoryApi.PUT_UNRESERVE_SERVICE_NOS;
  return axios.put(url, payload);
};

export const getUnReserveNumbers = (page: number, size: number, brn: string) => {
  const page1: string = page.toString();
  const size1: string = size.toString();
  const url = `${inventoryApi.GET_ALL_UNRESERVE_SERVICE_NOS}?page=${page1}&size=${size1}&brn=${brn}`;
  return axios.get(url);
};
